<!--component html goes here -->
<div #bussinessAlert>
  <div *ngIf="showBussinessAlert" class="bussiness-alert-banner text-left">
    <div class="container">
      <div class="row">
        <div class="col-11 p-0" role="alert" tabindex="0">
          <div class="business-alert-details">
            <div class="business-alert-message business-alert-display-block">
              <p class="mb-0" innerHTML="{{ businessMessage }}">.</p>
            </div>
          </div>
        </div>
        <div class="business-alert-close col-1 pr-0 pl-0">
          <button
            (click)="closeBussinessAlertBanner()"
            class="bussiness-alert-close business-close-icon float-right circle-outline"
            role="button"
          >
            <span class="sr-only">Close</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
